import React from 'react';
import { PlusIcon } from '@radix-ui/react-icons';

import { CreateStepDialog } from './create-step.dialog';
import { openModal } from '../../../core/modal/open-modal';

import styles from './create-step-button.module.scss';

type CreateStepButtonProps = {
  stageId: string;
  /** Only for the accessible name — a column of row headers holds one of these per stage. */
  stageName: string;
};

/**
 * The calendar's stage row header shows this where the `completed/total` caption sits everywhere
 * else (`stage-header.tsx`'s `showCount`). The board's equivalent is `CreateStepIndicator`, the
 * full-width "Add a step" line under a column — same dialog, but it has room for a label and this
 * does not.
 *
 * `openModal` rather than the local `useState` + inline render `CreateStepIndicator` uses: this
 * button is unmounted the moment its row scrolls out of the gantt's virtualized window, which
 * would take a locally-owned dialog down with it. The modal store outlives the row.
 */
export const CreateStepButton: React.FC<CreateStepButtonProps> = ({ stageId, stageName }) => (
  <button
    type="button"
    className={styles['button']}
    aria-label={`Add a step to ${stageName}`}
    onClick={(event) => {
      // See the sibling `stopPropagation` in `step-gantt-header.tsx`: row headers own click
      // behaviour of their own, and this button's click is not it.
      event.stopPropagation();
      openModal(CreateStepDialog, { stageId });
    }}
  >
    <PlusIcon />
  </button>
);
